import WrapperService from "@/modules/core/services/wrapper-service";
import {createPageableParams} from "@/modules/core/services/table-utils";

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/building'
const API_STATIC_URL = process.env.VUE_APP_ROOT_STATIC + '/building'

const sortTableFields = ['address_city', 'address_street'];
const sortDatabaseFields = ['address.city', 'address.street'];

const sortFacilityTableFields = ['typeName', 'buildingStreet'];
const sortFacilityDatabaseFields = ['type.name', 'building.address.street'];

const serviceName = 'Building-Service: ';

export default class BuildingService {

  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async readAllBuildingByCompanyId(companyId, successF, errorF) {
    await WrapperService.get(API_URL + '/company/' + companyId, null, serviceName, successF, errorF);
  }

  static async readLoggedCustomerFromAPI(successF, errorF) {
    await WrapperService.get(API_URL + '/by-logged-customer', null, serviceName, successF, errorF);
  }

  static async readAllPaginatedFromAPI(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page,size,search,sort,sortAsc,sortTableFields,sortDatabaseFields)
    await WrapperService.get(API_URL + '/page', {params : params}, serviceName, successF, errorF);
  }

  static async readFromAPI(buildingID, successF, errorF) {
    await WrapperService.get(API_URL + '/' + buildingID, null, serviceName, successF, errorF);
  }

  static async readBasicFromAPI(buildingID, facilityID, successF, errorF) {
    await WrapperService.get( API_URL + '/basic/' + buildingID + '/' + facilityID, null, serviceName, successF, errorF);
  }

  static postToAPI(building, successF, errorF) {
    WrapperService.post(API_URL, building, serviceName, successF, errorF);
  }

  static putToAPI(building, successF, errorF) {
    WrapperService.put(API_URL + '/' + building.id, building, serviceName, successF, errorF);
  }

  static deleteFromAPI(building, softDelete, successF, errorF) {
    if (softDelete) {
      WrapperService.delete(API_URL + '/' + building.id, serviceName, successF, errorF);
    } else {
      WrapperService.delete(API_URL + '/' + building.id + '/true', serviceName, successF, errorF);
    }
  }

  static restoreFromAPI(building, successF, errorF) {
    WrapperService.put(API_URL + '/restore/' + building.id, null, serviceName, successF, errorF);
  }

  static async readFacilitiesForBuilding(buildingID, successF, errorF) {
    await WrapperService.get(API_URL + '/' + buildingID + '/facilities', null, serviceName, successF, errorF);
  }

  static async readAllPaginatedFacilitiesForBuilding(buildingID, page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page,size,search,sort,sortAsc,sortFacilityTableFields,sortFacilityDatabaseFields)
    await WrapperService.get(API_URL + '/' + buildingID + '/facilities' + '/page', {params : params}, serviceName, successF, errorF);
  }

  static async uploadBuildingImage(buildingId, file, successF, errorF) {
    let formData = new FormData();
    formData.append('media', file, file.name);
    WrapperService.post(API_URL + '/' + buildingId + '/image', formData, serviceName, successF, errorF);
  }

  static async deleteBuildingImage(buildingId, successF, errorF) {
    WrapperService.delete(API_URL + '/' + buildingId + '/image', serviceName, successF, errorF);
  }

  static existsImage(buildingId, successF, errorF) {
    WrapperService.get(API_STATIC_URL + '/' + buildingId, null, serviceName, successF, errorF);
  }

  static async getFacilitiesForBuildings(buildingList, customerId, successF, errorF){
    await WrapperService.post(API_URL + '/get-building-with-facilities/' + customerId, buildingList, serviceName, successF, errorF);
  }
}
